import React from 'react';
import { Stack, Typography, Card, CardContent, Divider, Button, useMediaQuery } from '@mui/material';
import defaultImage from './default.png';

import { useStaff } from '../../pages/Staff';
import { useManager } from '../../pages/Manager';
import { staffUpdatePhotoAction } from '../../services/request';
import ImageModal from '../employee/generics/components/ImageModal';
import { useMutation } from 'react-fetching-library';
import toast from 'react-hot-toast';

const StaffDetails = ({ manager }) => {
  const { application } = manager ? useManager() : useStaff();
  const fileInputRef = React.useRef();
  const isMobile = useMediaQuery('(max-width:600px)');
  const { mutate, loading } = useMutation(staffUpdatePhotoAction);
  const [openImage, setOpenImage] = React.useState(false);
  const [preview, setPreview] = React.useState(!application.photo ? defaultImage : application.photo);

  const handleChangeImage = async e => {
    const image = e.target.files[0];
    if (['image/jpg', 'image/jpeg', 'image/png'].includes(image.type)) {
      const formData = new FormData();
      formData.append('photo', image);
      const { error, payload, loading } = await mutate(application.id, formData);
      if (!error && !loading) {
        const r = new FileReader();
        r.onload = e => {
          setPreview(e.target.result);
        };
        r.readAsDataURL(image);
      } else {
        toast.error('Nie udało się wczytać pliku');
      }
    } else {
      toast.error('Nieprawidłowy format pliku. Proszę wczytać plik w formacie JPG/JPEG/PNG.');
    }
  };

  console.log(application);

  const personalDetails = [
    { label: 'Imię i nazwisko:', value: `${application.name} ${application.surname}` },
    { label: 'Data urodzenia:', value: application.birth_date },
    { label: 'Miejsce urodzenia:', value: application.place_of_birth },
    { label: 'Numer telefonu:', value: application.phone },
    { label: 'E-mail do korespondencji:', value: application.correspondence_email },
    { label: 'PESEL:', value: application.pesel }
  ];

  const addressDetails = [
    { label: 'Ulica:', value: `${application.address.street} ${application.address.house}` },
    { label: 'Miejscowość:', value: application.address.city },
    { label: 'Kod Pocztowy:', value: application.address.postal_code },
    { label: 'Nazwa firmy:', value: application.company_name },
    { label: 'NIP:', value: application.nip },
    { label: 'Nr konta:', value: application.account_number }
  ];

  const experienceDetails = [
    { label: 'Funkcja', value: application.function_type_display },
    { label: 'Edukacja', value: application.education },
    { label: 'Obecny status zatrudnienia', value: application.current_employee_status },
    { label: 'Doświadczenie w pracy na obozach lub zielonych szkołach', value: application.experience },
    { label: 'Jakie doświadczenie?', value: application.what_experience },
    { label: 'Gdzie?', value: application.where_experience },
    { label: 'W jakiej roli?', value: application.role_experience }
  ];

  const skillDetails = [
    { label: 'Preferowane grupy wiekowe', value: application.preferred_age_group },
    { label: 'Uprawnienia pedagogiczne', value: application.pedagogical_qualifications.join(', ') },
    { label: 'Inne uprawnienia pedagogiczne', value: application.other_pedagogical_qualifications },
    { label: 'Pozostałe uprawnienia', value: application.additional_qualifications.join(', ') },
    { label: 'Inne uprawnienia', value: application.other_additional_qualifications },
    { label: 'Zakres umiejętności', value: application.range_of_skills.join(', ') },
    { label: 'Inne umiejętności', value: application.other_skills }
  ];

  const renderDetails = details => details.map(({ label, value }) => (
    <Stack key={label} p={1} minHeight={68}>
      <Typography variant="subtitle2" color="primary">{label}</Typography>
      <Typography sx={{ fontWeight: 'normal' }} variant="h5" mb={2}>
        {value}
      </Typography>
      <Divider />
    </Stack>
  ));

  return (
    <Stack direction={isMobile ? 'column' : 'row'} spacing={3} width="100%" alignItems={isMobile ? 'center' : 'flex-start'}>
      <Card sx={{ height: '250px', width: isMobile ? '100%' : '50%', textAlign: 'center' }}>
        <CardContent>
          <img
            src={preview}
            style={{ objectFit: 'cover', width: '150px', height: '150px', margin: '0 auto', border: '2px solid #00AB55', borderRadius: '16px', cursor: 'zoom-in' }}
            onClick={() => setOpenImage(true)}
          >
          </img>
          <Stack style={{ marginTop: '10px' }} direction="row" justifyContent="center">
            <Button variant="contained" component="label" disabled={loading}>
                  Zmień
              <input type="file" accept="image/*" hidden ref={fileInputRef} onChange={handleChangeImage}/>
            </Button>
          </Stack>
        </CardContent>
      </Card>
      <Card sx={{ width: '100%' }}>
        <CardContent>
          {renderDetails(personalDetails)}</CardContent>
      </Card>
      <Card sx={{ width: '100%' }}>
        <CardContent>{renderDetails(addressDetails)}</CardContent>
      </Card>
      <Card sx={{ width: '100%' }}>
        <CardContent>{renderDetails(experienceDetails)}</CardContent>
      </Card>
      <Card sx={{ width: '100%' }}>
        <CardContent>{renderDetails(skillDetails)}</CardContent>
      </Card>
      <ImageModal open={openImage} handleClose={() => setOpenImage(false)} src={preview}/>
    </Stack>
  );
};

export default StaffDetails;
